import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, parseOptions} from '../question-helper';

@Component({
    selector: 'app-question-items-specify',
    templateUrl: './question-items-specify.component.html',
    styleUrls: ['./question-items-specify.component.scss'],
    standalone: false
})
export class QuestionItemsSpecifyComponent implements OnInit, OnChanges {

  @Input() question: Question;
  @Input() readonly = false;
  @Input() selectedValue: any;
  @Output() questionAnswer = new EventEmitter();

  uniqueControllerName = `item-specify-name-${newGuid()}`;
  items: any[] = [];

  constructor() { }

  ngOnInit(): void {
    if(this.question) {
      this.items = parseOptions(this.question.options);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue) {
      this.items = parseOptions(changes?.question?.currentValue?.options);
    }
  }

  checkRadio(answer: any): void {
    if (this.question) {
      this.question.answer = answer;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(answer);
    }
  }

}
